import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const SkeletonWrapper = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
`;

const SkeletonImage = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 8px;
  background: linear-gradient(
    90deg,
    rgb(231, 231, 231) 25%,
    #e0e0e0 50%,
    #f0f0f0 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
`;

const SkeletonContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

const SkeletonText = styled.div<{ width?: string; height?: string }>`
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "16px"};
  background: linear-gradient(
    90deg,
    rgb(231, 231, 231) 25%,
    #e0e0e0 50%,
    #f0f0f0 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 4px;
`;

const SkeletonHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CompetitionItemSkeleton = () => {
  return (
    <SkeletonWrapper>
      <SkeletonImage />
      <SkeletonContent>
        <SkeletonHeader>
          <SkeletonText width="70%" height="18px" />
          <SkeletonText width="60px" height="19px" />
        </SkeletonHeader>
        <SkeletonText width="80%" height="13px" />
        <SkeletonText width="90%" height="13px" />
      </SkeletonContent>
    </SkeletonWrapper>
  );
};

export default CompetitionItemSkeleton;
